import client from "./axiosConfig";

export const getNotification = (params) => {
  const config = {
    url: "/notifications/",
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const MarkAsRead = (id, payload) => {
  const config = {
    url: `/notifications/${id}/`,
    method: "PATCH",
    data: payload,
  };
  const response = client(config);
  return response;
};

export const markAllAsRead = () => {
  const config = {
    url: `/notifications/mark-all-read/`,
    method: "PATCH",
  };
  const response = client(config);
  return response;
};

export const getUnreadCounts = () => {
    const config = {
      url: `/notifications/unread-count/`,
      method: "GET",
    };
    const response = client(config);
    return response;
}
